<template>
<div class="happy_nodata">
    <div class="wrap">
        <div class="img_wrap">
            <img src="../../assets/images/parent-course/happyData.png" alt="">
        </div>
        <p>暂无数据</p>
    </div>
</div>
</template>

<script>
export default {
  name: 'happy-data',
  components: {},
  props: {},
  data() {
    return {};
  },
  watch: {},
  computed: {},
  methods: {},
  beforeCreate() {},
  created() {},
  beforeMount() {},
  mounted() {},
  activated() {},
  deactivated() {},
  beforeDestroy() {},
  destroyed() {}
};
</script>

<style lang="scss">
.happy_nodata {
    // width: 100%;
    // height: 100%;
    .wrap {
        display: flex;
        flex-direction: column;
        justify-content: center;
        align-items: center;
        .img_wrap {
            width: 203px;
            height: 198px;
            margin: auto;
            img {
                width: 100%;
                height: 100%;
            }
        }
        p {
            height: 25px;
            margin-top: -20px;
            // width: 72px;
            font-size: 14px;
            font-weight: 500;
            color: #fff;
            margin-bottom: 30px;
            white-space: nowrap;
        }
    }
}
</style>